import { api, authHeader } from "../configs/axiosConfigs";

// Company Information
const getCompanyInformationListApi = async () => {
  const response = await api.request({
    url: `BI/Grid/CompanyInformation/GetList`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const getCompanyInformationByIdApi = async (id) => {
  const response = await api.request({
    url: `BI/Grid/CompanyInformation/GetById${id ? "?Id=" + id : ""}`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const modifyCompanyInformationApi = async (data) => {
  const response = await api.request({
    url: `BI/Grid/CompanyInformation/Modify`,
    method: "Post",
    data: data,
    headers: authHeader(),
  });

  return response.data;
};

const deleteCompanyInformationApi = async (data) => {
  const response = await api.request({
    url: `BI/Grid/CompanyInformation/Delete`,
    method: "Delete",
    data,
    headers: authHeader(),
  });

  return response.data;
};

// Province Information
const getProvinceInformationListApi = async () => {
  const response = await api.request({
    url: `BI/Grid/ProvinceInformation/GetList`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

// City Information - لیست شهرستان‌ها (از متد GetApiList)
const getCityInformationListApi = async () => {
  const response = await api.request({
    url: `BI/Grid/CityInformation/GetApiList`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const getCityInformationByIdApi = async (id) => {
  const response = await api.request({
    url: `BI/Grid/CityInformation/GetById${id ? "?Id=" + id : ""}`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const modifyCityInformationApi = async (data) => {
  const response = await api.request({
    url: `BI/Grid/CityInformation/Modify`,
    method: "Post",
    data: data,
    headers: authHeader(),
  });

  return response.data;
};

const deleteCityInformationApi = async (data) => {
  const response = await api.request({
    url: `BI/Grid/CityInformation/Delete`,
    method: "Delete",
    data,
    headers: authHeader(),
  });

  return response.data;
};

// DG Information
const getDGInformationListApi = async () => {
  const response = await api.request({
    url: `BI/Grid/DGInformation/GetList`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const getDGInformationByIdApi = async (id) => {
  const response = await api.request({
    url: `BI/Grid/DGInformation/GetById${id ? "?Id=" + id : ""}`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const modifyDGInformationApi = async (data) => {
  const response = await api.request({
    url: `BI/Grid/DGInformation/Modify`,
    method: "Post",
    data: data,
    headers: authHeader(),
  });

  return response.data;
};

const deleteDGInformationApi = async (data) => {
  const response = await api.request({
    url: `BI/Grid/DGInformation/Delete`,
    method: "Delete",
    data,
    headers: authHeader(),
  });

  return response.data;
};

const BasicInformationService = {
  getCompanyInformationListApi,
  getCompanyInformationByIdApi,
  modifyCompanyInformationApi,
  deleteCompanyInformationApi,

  getProvinceInformationListApi,

  getCityInformationListApi,
  getCityInformationByIdApi,
  modifyCityInformationApi,
  deleteCityInformationApi,

  getDGInformationListApi,
  getDGInformationByIdApi,
  modifyDGInformationApi,
  deleteDGInformationApi,
};

export default BasicInformationService;
